import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CHECKOUT_URL } from "./constants";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const trigger = document.getElementById("floating-cta-trigger");
    if (!trigger) return;
    const observer = new IntersectionObserver(([entry]) => {
      // Show once the first CTA has scrolled past the top of the viewport
      setVisible(entry.boundingClientRect.top < 0);
    }, {
      threshold: 0,
      rootMargin: "0px 0px -100% 0px"
    });
    observer.observe(trigger);
    return () => observer.disconnect();
  }, []);
  const handleClick = () => {
    if (typeof window !== "undefined" && window.fbq) {
      window.fbq("track", "InitiateCheckout");
    }
  };
  return <AnimatePresence data-id="element-86" data-mp="197rh11l8y1is">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: "spring",
      stiffness: 260,
      damping: 26
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-brand-dark/30 bg-white/95 p-3 shadow-[0_-8px_30px_-10px_rgba(0,0,0,0.25)] backdrop-blur" data-id="element-87" data-mp="14fq4dek628s8">
          <div className="mx-auto flex max-w-md items-center gap-3" data-id="element-88" data-mp="21at6ufef7u6d">
            <div className="hidden flex-col leading-tight xs:flex sm:flex" data-id="element-89" data-mp="26a5s4vpn8t6u">
              <span className="text-[11px] font-bold uppercase text-navy-800" data-id="element-90" data-mp="1rderkj48hbfn">Hoy solo</span>
              <span className="font-display text-xl font-extrabold text-brand" data-id="element-91" data-mp="1wem1anpxskoy">USD $13</span>
            </div>
            <motion.a href={CHECKOUT_URL} onClick={handleClick} whileTap={{
          scale: 0.97
        }} className="flex flex-1 items-center justify-center rounded-xl bg-brand px-4 py-3.5 text-center text-sm font-extrabold uppercase leading-tight text-white shadow-lg animate-pulse-cta sm:text-base" data-id="element-92" data-mp="1if35muebb1tj">
              Quiero el sistema
            </motion.a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}